<template>
  <div class="accountmanagement">
<!--    <div class="accountmanagement_left">-->
<!--      <div class="title">组织机构</div>-->
<!--      <el-input style="margin-top: 10px" suffix-icon="el-icon-search" placeholder="输入搜索" v-model="filterText">-->
<!--      </el-input>-->

<!--      <el-tree class="filter-tree" style="margin-top: 10px" :data="treeData"  :load="loadNode" lazy :props="defaultProps" :filter-node-method="filterNode" @node-click="handleNodeClick" node-key="id" highlight-current ref="tree">-->
<!--      </el-tree>-->
<!--    </div>-->
    <div class="accountmanagement_right">
      <div class="management-title">
        <div class="management-tel">
          <el-input v-model="username" placeholder="账号"></el-input>
        </div>
        <div class="management-tel">
          <el-input v-model="mobile" placeholder="手机号"></el-input>
        </div>
        <div class="management-tel">
          <el-select v-model="status" placeholder="状态">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="management-tel" style="width: 350px">
          <el-button style="width: 100px" type="primary" @click="handleSearch" plain>查询</el-button>
          <el-button style="width: 100px" type="info" @click="Reset()" plain>重置</el-button>
          <el-button style="width: 100px" type="primary" plain @click="routing()" v-if="filtering('user:add')">新建人员</el-button>
        </div>
      </div>
      <div class="accountmanagement_func" v-if="filtering('user:update')">
        <el-button @click="Allowlogin('2')" :disabled="disabled" v-if="filtering('user:noLogin')">禁止登录</el-button>
        <el-button @click="Allowlogin('3')" :disabled="disabled" v-if="filtering('user:noLogin')">恢复登陆</el-button>
        <el-button @click="resetpassword()" :disabled="disabled" v-if="filtering('user:password:reset')">重置密码</el-button>
        <el-button @click="Allowlogin('0')" :disabled="disabled" v-if="filtering('user:deactivate')">停用</el-button>
        <el-button @click="Allowlogin('1')" :disabled="disabled" v-if="filtering('user:deactivate')">恢复</el-button>
      </div>
      <div class="management-body" v-if="filtering('user:view')">
        <el-table :data="tableData" @selection-change="selectL" border style="width: 100%">
          <el-table-column fixed type="selection" width="50" align="center">
          </el-table-column>
          <el-table-column prop="username" label="账号" width="120">
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="120">
          </el-table-column>
          <el-table-column prop="realname" label="姓名" width="120">
          </el-table-column>
          <el-table-column prop="deptName" label="主机构" width="150">
          </el-table-column>
          <el-table-column prop="status" :formatter="formtype" label="状态" width="80">
          </el-table-column>
          <el-table-column prop="loginStatus" :formatter="formtypes" label="登录状态" width="100">
          </el-table-column>
          <el-table-column prop="description" label="备注" min-width="250">
          </el-table-column>
          <el-table-column fixed="right" label="操作" min-width="250" v-if="filtering('user:update')">
            <template #default="scope">
              <el-button @click="routing(scope.row)" v-if="filtering('user:update')" type="text" size="small">编辑</el-button>
              <el-button v-if="scope.row.loginStatus == '3'&&filtering('user:noLogin')" @click="Disablelogin(scope.row, '2')" type="text" size="small">禁止登录</el-button>
              <el-button v-if="scope.row.loginStatus == '2'&&filtering('user:noLogin')" @click="Disablelogin(scope.row, '3')" type="text" size="small">允许登录</el-button>
              <el-button @click="resetpassword(scope.row)" v-if="filtering('user:password:reset')" type="text" size="small">重置密码</el-button>
              <el-button v-if="scope.row.status == '1'&&filtering('user:deactivate')" @click="Disablelogin(scope.row, '0')" type="text" size="small">停用</el-button>
              <el-button v-if="scope.row.status == '0'&&filtering('user:deactivate')" @click="Disablelogin(scope.row, '1')" type="text" size="small">恢复</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 20px 0 0 0; text-align: center">
          <el-pagination background layout="total, sizes , prev, pager, next , jumper" :current-page="pageNum" :total="total" @current-change="handleCurrentChange" @size-change="chanegesize">
          </el-pagination>
        </div>
      </div>
      <!-- 编辑弹窗 -->
      <vs-prompt title="机构信息" :active.sync="dialogVisible" @close="closeModal" class="form_box">
        <div class="con-exemple-prompt">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="账号" prop="accountnumber">
              <el-input style="width: 300px" v-model="ruleForm.accountnumber" placeholder="请输入账号" :disabled="!whether"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="name">
              <el-input style="width: 300px" v-model="ruleForm.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phonenumber">
              <el-input style="width: 300px" maxlength="11" v-model="ruleForm.phonenumber" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item v-if="showPwd" label="初始密码" prop="Initial">
              <el-input style="width: 300px" v-model="ruleForm.Initial" show-password placeholder="请输入密码" :disabled="!whether"></el-input>
            </el-form-item>
<!--            <el-form-item label="角色" prop="roleId">-->
<!--              <el-select v-model="ruleForm.roleId" multiple style="width: 300px" placeholder="请选择">-->
<!--                <el-option v-for="item in Datapermissions" :key="item.value" :label="item.roleName" :value="item.roleId">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->

            <el-form-item label="备注" prop="desc">
              <el-input style="width: 300px" type="textarea" v-model="ruleForm.desc" placeholder="请输入备注"></el-input>
            </el-form-item>
            <div>
              <div class="management-customer">组织信息</div>
              <el-form-item label="主机构" prop="deptId">
                <el-input v-show="!isEdit" @focus="showEditTree" style="width: 300px" v-model="tempName"></el-input>
                <el-cascader v-show="isEdit" placeholder="主机构" :options="data" :props="cascaderProps" style="width: 300px" @change="getcascadercode" v-model="ruleForm.deptId" :show-all-levels="false" filterable
                  clearable></el-cascader>
              </el-form-item>
<!--              <el-form-item label="附属机构" prop="deptIds">-->
<!--                <el-cascader placeholder="附属机构" :options="data" v-model="ruleForm.deptIds" :props="subsidiaryProps" @change="adercode" style="width: 300px" filterable></el-cascader>-->
<!--              </el-form-item>-->
            </div>
          </el-form>
        </div>
        <div class="exemple_footer">
          <el-button type="primary" style="width: 100px" @click="getadd()" plain>保存</el-button>
          <el-button style="width: 100px" @click="closeModal">取消</el-button>
        </div>
      </vs-prompt>
    </div>
  </div>
</template>

<script>
import { OrderApi } from "@/modules/accounts/getapi";
var validatorPhone = function (rule, value, callback) {
  if (value === "") {
    callback(new Error("手机号不能为空"));
  }else {
    callback();
  }
};
export default {
  name: "accountmanagement",

  data () {
    return {
      isEdit:false,//是否是编辑flag
      tempName:'',//临时字段缓存机构名称
      treeData:[],
      showPwd:true,
      filterText: "",
      data: [],
      tableData: [],
      defaultProps: {
        children: "children",
        label: "name",
        checkStrictly: true
      },
      cascaderProps: {
        children: "children",
        label: "name",
        value: "id",
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node,resolve) {
          console.log(node);
          let id = node.data.id;
          let res = await OrderApi.structure({}, id);
          console.log(res.data);
          resolve(res.data);
        }
      },
      subsidiaryProps: {
        children: "children",
        label: "name",
        value: "id",
        multiple: true,
        checkStrictly: true,
      },

      dialogVisible: false,
      ruleForm: {
        accountnumber: "", //账号
        name: "", //姓名
        phonenumber: "", //手机号
        Initial: "", //初始密码
        desc: "", //备注
        deptId: "", //机构id
        // deptIds: "", //附属机构
        // roleId: "", //数据权限
      },
      rules: {
        accountnumber: [
          { required: true, message: "请输入账号", trigger: "blur" },
          {
            min: 4,
            max: 12,
            message: "长度在不能小于4位大于10位字符",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // roleId: [
        //   { required: true, message: "请选择数据权限", trigger: "blur" },
        // ],

        phonenumber: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        deptId: [{ required: true, message: "请选择主机构", trigger: "blur" }],
      },
      options: [
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "有效",
        },
      ],
      status: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      mobile: "",
      username: "",
      disabled: true, //是否勾选复选框
      geonlist: [], //复选框选中列表
      deptId: "",
      Datapermissions: [], //数据权限
      whether: true, //是否编辑
      id: "", //编辑id
    };
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
    geonlist (val) {
      if (val.length == 0) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
  },
  created () {
    this.organization(0);
    this.getaccountmanage();
  },

  mounted () { },

  methods: {
    closeModal(){
      this.isEdit = false;
      this.dialogVisible = false;
      this.tempName = '';
    },
    //点击文本显示懒加载tree
    showEditTree(){
      this.isEdit = true;
    },
    async loadNode(node,resolve){
      let id;
      if(node.level === 0){
        id = 0
      }else{
        id = node.data.id
      }

      let res = await OrderApi.structure({},id);
      console.log(res.data);
      resolve(res.data);
      // this.isLoading = false;
    },
    adercode (e) {
      let list = JSON.parse(JSON.stringify(e));
      this.ruleForm.deptIds = list;
    },
    //获取选中行
    selectL (selection, row) {
      this.geonlist = selection.map((item) => item.userId); //选中的id
      this.usernamelist = selection.map((item) => item.username); //选中的账号

      //console.log(this.usernamelist)
    },
    //判断状态
    formtype (row) {
      if (row.status == 1) {
        return "启用";
      } else if (row.status == 0) {
        return "禁用";
      }
    },
    //判断状态
    formtypes (row) {
      if (row.loginStatus == 2) {
        return "无法登录";
      } else if (row.loginStatus == 3) {
        return "正常";
      }
    },
    //选择主机构
    getcascadercode (e) {
      this.ruleForm.deptId = JSON.parse(JSON.stringify(e));
      //console.log(this.ruleForm.deptId,this.ruleForm.deptIdup)
    },
    //重置
    Reset () {
      this.mobile = "";
      this.username = "";
      this.status = "";
      this.deptId = "";
      this.pageSize = 10;
      this.pageNum = 1;
      this.$nextTick(()=>{
        this.getaccountmanage();

      })
    },
    //选择组织机构
    handleNodeClick (e) {
      this.deptId = e.id;
      this.getaccountmanage();
    },
    //触发分页
    handleCurrentChange (val) {
      this.pageNum = val;
      this.getaccountmanage();
    },
    //修改当前页面展示多少条
    chanegesize (val) {
      this.pageSize = val;
      this.getaccountmanage();
    },

    //获取组织机构
    async organization (id) {
      // let res = await OrderApi.organization({ id: "0" });
      let res = await OrderApi.structure({},id);
      this.data = res.data;
    },
    //查询
    handleSearch(){
      this.pageNum = 1;
      this.getaccountmanage();
    },
    //获取列表
    async getaccountmanage () {
      let data = {
        current: this.pageNum,
        size: this.pageSize,
        data: {
          mobile: this.mobile,
          username: this.username,
          status: this.status,
          deptId: this.deptId,
        },
      };
      let res = await OrderApi.getaccountmanage(data);
      this.tableData = res.data.records;
      this.total = res.data.total;
    },
    //保存
    getadd () {
      //console.log("保存");
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.ruleForm.deptId = Array.isArray(this.ruleForm.deptId)?this.ruleForm.deptId.pop():this.ruleForm.deptId;
          let data = {
            username: this.ruleForm.accountnumber, //账号
            password: this.ruleForm.Initial, //密码
            realname: this.ruleForm.name, //姓名
            sex: "0", //性别
            loginStatus: "3",
            deptId:this.ruleForm.deptId,//主机构id
            mobile: this.ruleForm.phonenumber, //电话
            // deptIds: [this.ruleForm.deptId.toString()], //主机构id
            status: "1",
            description: this.ruleForm.desc, //备注
            // deptPermissionIds: arr.length == 0 ? [] : arr, //附属机构
            // roleId: this.ruleForm.roleId.toString(),
            id: this.id,
          };
          if (this.whether) {
            this.addUser(data);
          } else {
            this.editUser(data);
          }
        } else {
          return false;
        }
      });
    },
    //添加机构信息
    async addUser (data) {
      delete data.id;
      let res = await OrderApi.addUser(data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "新建成功!",
        });
        this.dialogVisible = false;
        this.getaccountmanage();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    //添加机构信息
    async editUser (data) {
      delete data.password;
      let res = await OrderApi.editUser(data);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功!",
        });
        this.dialogVisible = false;
        this.isEdit = false;
        this.getaccountmanage();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    queryTree (tree, id) {
      let stark = [];
      stark = stark.concat(tree);
      //console.log(stark)
      while (stark.length) {
        const temp = stark.shift();
        if (temp[this.data.children]) {
          stark = stark.concat(temp[this.data.children]);
        }
        if (temp[this.data.value] === id) {
          return temp[this.data.name];
        }
      }
      return "";
    },

    //编辑
    async routing (e) {
      var that = this;

      this.ruleForm.accountnumber = "";
      this.ruleForm.name = "";
      this.ruleForm.phonenumber = "";
      this.ruleForm.Initial = "";
      this.ruleForm.desc = "";
      this.ruleForm.deptId = "";
      // this.ruleForm.deptIds = "";
      // this.ruleForm.roleId = "";
      //console.log(that.ruleForm)
      let res = await OrderApi.Rolelist({});
      this.Datapermissions = res.data;
      this.dialogVisible = true;
      console.log(e);
      if (e) {
        //编辑
        this.showPwd = false;
        this.whether = false;
        this.tempName = e.deptName;
        that.id = e.id;
        that.ruleForm.accountnumber = e.username;
        that.ruleForm.name = e.realname;
        that.ruleForm.phonenumber = e.mobile;
        // that.ruleForm.Initial = e.password;

        that.ruleForm.desc = e.description;
        that.ruleForm.deptId = e.deptId;
        // that.ruleForm.deptIds = e.deptPermissionIds;

        let arr = [];
        e.roleId.split(",").map((item) => {
          let str = Number(item);
          arr.push(str);
        });
        that.ruleForm.roleId = arr;
      } else {
        this.showPwd = true;
        //新增
        this.whether = true;
      }
    },

    //搜索树状图
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //表格上面的操作
    Allowlogin (type) {
      let str;
      if (type === "0") {
        str = "确定要停用账号？";
      } else if (type === "2") {
        str =
          "被禁止登录的帐号在帐号密码正确的情况下也无法正常登录系统，确定禁止登录？";
      } else if (type === "3") {
        str = "确认恢复用户账号？";
      } else if (type === "1") {
        str = "确定要恢复账号？";
      }
      this.open(str, type); //0禁止登录 1停用 2允许登录 3恢复
    },
    // 表格中的操作
    Disablelogin (e, type) {
      let str;
      if (type === "0") {
        str = "确定要停用账号？";
      } else if (type === "2") {
        str =
          "被禁止登录的帐号在帐号密码正确的情况下也无法正常登录系统，确定禁止登录？";
      } else if (type === "3") {
        str = "确认恢复用户账号？";
      } else if (type === "1") {
        str = "确定要恢复账号？";
      }
      this.open(str, type, e.userId); //0禁止登录 1停用 2允许登录 3恢复
    },
    //重置密码
    resetpassword (e) {
      this.$prompt("重置密码后，系统会发短信通知员工", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "password",
        inputSize: "small",
      })
        .then(({ value }) => {
          let data = {
            usernames: e ? [e.username] : this.usernamelist,
            password: value,
          };
          this.ChangePassword(data);
        })
        .catch(() => { });
    },
    // 修改密码
    async ChangePassword (data) {
      let res = await OrderApi.ChangePassword(data);
      //console.log(res)
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.getaccountmanage();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
    //弹框操作
    open (text, type, userId) {
      this.$confirm(text, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        center: true,
      })
        .then(() => {
          this.Stateoperation(userId, type);
        })
        .catch(() => { });
    },
    //操作
    async Stateoperation (userId, type) {
      let data = {
        status: type,
        userIds: userId ? [userId] : this.geonlist,
      };
      let res = await OrderApi.Stateoperation(data);
      //console.log(res)
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "成功!",
        });
        this.getaccountmanage();
      } else if (res.code == 403) {
        console;
      } else {
        this.$message({
          type: "error",
          message: res.message,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .accountmanagement {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .accountmanagement_left {
    /*width: 200px;*/
    height: 100%;
    background: #fff;
    padding: 15px;
    .title {
      font-size: 20px;
    }
  }

  .accountmanagement_right {
    flex: 1;
    overflow-x: auto;
    background: #fff;
    /*margin-left: 20px;*/
    padding: 15px;
    height: 100%;
    .management-title {
      display: flex;
      flex-wrap: wrap;
    }
    .management-tel {
      width: 200px;
      height: 40px;
      margin-right: 20px;
      margin-bottom: 20px;
      & > input {
        width: 100%;
        height: 100%;
      }
    }
    .accountmanagement_func {
      width: 100%;
      height: 40px;
    }
    .management-body {
      width: 100%;
      min-height: 200px;
      margin-top: 20px;
    }
  }

  .form_box {
    /deep/ .vs-dialog-text {
      position: relative;
    }
  }
  .form_box {
    /deep/ .vs-component {
      display: none;
    }
    /deep/ footer {
      height: 60px;
    }
  }
  .con-exemple-prompt {
    width: 100%;
    height: 500px;
    overflow: auto;
  }
  .exemple_footer {
    width: 32%;
    height: 50px;
    position: absolute;
    z-index: 999999;
    bottom: -60px;
    right: 16px;
    background: white;
  }
  .management-customer {
    font-size: 20px;
    font-weight: bold;
    padding-bottom: 20px;
  }
</style>
